import React, { useState } from "react";
import { useLang } from "@/contexts/LangContext";
import { Users, Layers, Wrench, Settings2, BookOpen, Handshake } from "lucide-react";
import Team from "@/pages/Team";
import StagesAdmin from "@/components/admin/StagesAdmin";
import ServicesAdmin from "@/components/admin/ServicesAdmin";
import SettingsAdmin from "@/components/admin/SettingsAdmin";
import ExpenseAccountsAdmin from "@/components/admin/ExpenseAccountsAdmin";
import BeneficiariesAdmin from "@/components/admin/BeneficiariesAdmin";

const TABS = [
  { k: "users", icon: Users, label: "team" },
  { k: "stages", icon: Layers, label: "stages_config" },
  { k: "services", icon: Wrench, label: "services_config" },
  { k: "accounts", icon: BookOpen, label: "expense_accounts" },
  { k: "beneficiaries", icon: Handshake, label: "beneficiaries" },
  { k: "settings", icon: Settings2, label: "general_settings" },
];

const Admin = () => {
  const { t } = useLang();
  const [tab, setTab] = useState("users");

  return (
    <div className="space-y-6" data-testid="admin-view">
      <div>
        <h2 className="text-2xl sm:text-3xl font-bold tracking-tight text-slate-900" style={{ fontFamily: "'Outfit', sans-serif" }}>
          {t("administration")}
        </h2>
        <p className="text-sm text-slate-500 mt-1">{t("admin_desc")}</p>
      </div>

      <div className="flex flex-wrap gap-1 p-1 bg-slate-100 rounded-full w-fit" data-testid="admin-tabs">
        {TABS.map(({ k, icon: Icon, label }) => (
          <button
            key={k}
            data-testid={`admin-tab-${k}`}
            onClick={() => setTab(k)}
            className={`flex items-center gap-1.5 px-4 py-2 text-xs font-semibold rounded-full transition-colors ${
              tab === k ? "bg-white shadow text-slate-900" : "text-slate-500 hover:text-slate-800"
            }`}
          >
            <Icon className="w-3.5 h-3.5" /> {t(label)}
          </button>
        ))}
      </div>

      {tab === "users" && <Team />}
      {tab === "stages" && <StagesAdmin />}
      {tab === "services" && <ServicesAdmin />}
      {tab === "accounts" && <ExpenseAccountsAdmin />}
      {tab === "beneficiaries" && <BeneficiariesAdmin />}
      {tab === "settings" && <SettingsAdmin />}
    </div>
  );
};

export default Admin;
